
const H6 = ({ children, additionalclasses }) => (
  <span
    className={`custom-text-grey-500  poppins-bold text-[20px] leading-[24px] tracking-[-0.4px] ${additionalclasses}`}
  >
    {children}
  </span>
);

export default H6;
